const api = {
  GET_LIST_CHANNEL_PROVIDER: '/index.php?r=api/v1/channel_provider/channel-provider',
  CREATE_CHANNEL_PROVIDER: '/index.php?r=api/v1/channel_provider/channel-provider/create',
  UPDATE_CHANNEL_PROVIDER: '/index.php?r=api/v1/channel_provider/channel-provider/update',
  DELETE_CHANNEL_PROVIDER: '/index.php?r=api/v1/channel_provider/channel-provider/delete',
};

export default api;
